













































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import VehiclesActions from './VehiclesActions.vue';
@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        VehiclesActions
    }
})
export default class ModalVehicleActions extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: '' }) selectedVehiclesNames: string;
    @Prop({ default: {} }) vehicleProperties: object;
    @Prop({
        default() {
            return [];
        }
    })
    selectedVehicles: Array<string>;
    activationVehicleStatus: number | null = null;
    activationVehicleStatusMsg: string = '';
    modalTitle: string = 'Acciones';
    pendingRequest: boolean = false;
   

    @Emit()
    updateVehicleActivationStatus(activationStatus, msg) {
        this.activationVehicleStatus = activationStatus;
        this.activationVehicleStatusMsg = this.vehicleProperties['all_activation_status'][activationStatus];
    }

    submit() {
        // this.generateSuscription();
    }

    @Emit()
    closeModal() {
        this.activationVehicleStatus = null;
        this.activationVehicleStatusMsg = '';
    }

    @Emit()
    deactivateNormsSuccess(vehiclesIds: string[]){}
    
    @Emit()
    deactivateAlertsSuccess(vehiclesIds: string[], acknowledgeTime: string | null){}

    mounted() {
        this.$nextTick(() => {
            // this.loadPatchData();
        });
    }
}
